import React, { Component } from 'react';

export default class CreateShipment extends Component {
  render() {
    return (
    <div className="card">
      <div className="card-header">
        <strong>New Shipment</strong>
      </div>

      <div className="card-block">
        <form>
          <div className={`form-group ${(this.props.errors.indexOf('destination') !== -1) ? "has-danger" : ""}`}>
            <label className="col-sm-4 col-form-label" htmlFor="select">Destination</label>
            <div className="col-sm-8">
              <select id="select" name="select" className={(this.props.errors.indexOf('destination') !== -1) ? "form-control form-control-danger" : "form-control"} size="1"
                      onChange={this.props.onDestinationChange}>
                <option value="0">Please select destination</option>
                  {this.props.destinations.map((d,index) => {
                        return(<option value={d.id} key={d.id}>{d.name}</option>)
                      })
                  }
              </select>
            </div>
            {(this.props.errors.indexOf('destination') !== -1)? <em id="firstname-error" className="error form-control-feedback">Please select destination</em> : <em></em>}
          </div>
        </form>
      </div>

      <div className="card-footer">
        <button type="submit" className="btn btn-primary" onClick={this.props.createShipment}>Create</button>
        <button type="reset" className="btn btn-danger" onClick={this.props.cancelShipment}>Cancel</button>
      </div>
    </div>
    );
  }
}
